import { createFileRoute } from '@tanstack/react-router';
import { CleanerRegistrationSetup } from '@/features/cleaner/registrations/cleaner-setup';

export const Route = createFileRoute(
  '/(cleaner)/_registration/cleaner/signup-setup'
)({
  component: CleanerRegistrationSetup,
});
